import global from "../../../shared/utils/global.js";
import { main } from "../../units/unit-sensors/views/main/mainpage.js";
import { removeDetailPanes } from "../../units/unit-sensors/views/main/manageviews.js";

export const findTopLevelCustomer = (customers) => {
  const minPathLength = Math.min(...customers.map(c => c.path.length));
  return customers.find(c => c.path.length === minPathLength);
};

export function displayCustomerHierarchy(customers, parentCustomer, isToplevelCustomer) {
  global.customerId = parentCustomer.customerId;
  removeDetailPanes(); // Clear existing detail panes
  const mainPane = document.getElementById("mainpane");
  mainPane.style.display = 'none'; // Hide other divs

  const hierarchyContainer = document.getElementById("customerhierarchycontainer");
  hierarchyContainer.innerHTML = ""; // Clear existing content


  hierarchyContainer.classList.add("d-flex", "flex-wrap");

  if (isToplevelCustomer) {
    const card = createCustomerCard(parentCustomer, customers);
    hierarchyContainer.appendChild(card);
  } else {
    const displayCustomers = customers.filter(c =>
      c.parentCustomerId === parentCustomer.customerId
    );

    displayCustomers.forEach(customer => {
      const card = createCustomerCard(customer, customers);
      hierarchyContainer.appendChild(card);
    });
  }

  hierarchyContainer.style.display = 'block';
  const splashContainer = document.getElementById('splashcontainer');
  if (splashContainer) splashContainer.style.display = 'none';
  const unitsContainer = document.getElementById('unitscontainer');
  if (unitsContainer) unitsContainer.style.display = 'none';
  // document.getElementById('mainpane').style.display = 'none';
  // document.getElementById('detailspane').style.display = 'none'
  document.body.style.cursor = 'default';
}

export function createCustomerCard(customer, customers) {
  const card = document.createElement("div");
  card.className = "card mt-3 p-1 customer-card";
  card.style.width = "12.5rem";

  const cardBody = document.createElement("div");
  cardBody.className = "card-body d-flex flex-column";

  const title = document.createElement("h5");
  title.className = "card-title fs-5 customer-card-title";
  title.textContent = customer.name;

  const customerCount = document.createElement("p");
  customerCount.className = "customer-count";
  customerCount.textContent = `Customers: ${customer.childCount}`;

  const viewCustomersBtn = document.createElement("button");
  viewCustomersBtn.className = "btn btn-primary view-customers";
  viewCustomersBtn.textContent = "View Customers";

  // 🔁 Recursive unit count
  const totalUnitCount = getTotalUnitCount(customer.customerId, customers);

  const unitCount = document.createElement("p");
  unitCount.className = "unit-count";
  unitCount.textContent = `Units: ${totalUnitCount}`;

  const viewUnitsBtn = document.createElement("button");
  viewUnitsBtn.className = "btn btn-primary view-units";
  viewUnitsBtn.textContent = "View Units";

  // 🧠 Button logic
  if (customer.childCount === 0) {
    viewCustomersBtn.disabled = true;
    viewCustomersBtn.classList.add("btn-secondary");
    viewCustomersBtn.classList.remove("btn-primary");
  }

  if (totalUnitCount === 0) {
    viewUnitsBtn.disabled = true;
    viewUnitsBtn.classList.add("btn-secondary");
    viewUnitsBtn.classList.remove("btn-success");
  }

  // Button handlers
  viewCustomersBtn.addEventListener("click", () => {
    displayCustomerHierarchy(customers, customer, false);
  });

  viewUnitsBtn.addEventListener("click", () => {
    const mainpane = document.getElementById("mainpane");
    Array.from(mainpane.children).forEach(child => {
      if (child.id !== "customerhierarchycontainer") {
        child.style.display = 'block';
      }
    });
    const mainButtonPane = document.getElementById("mainbuttonspane");
    mainButtonPane.style.display = "flex";

    global.customerId = customer.customerId;
    main();
  });

  cardBody.appendChild(title);
  cardBody.appendChild(customerCount);
  cardBody.appendChild(viewCustomersBtn);
  cardBody.appendChild(unitCount);
  cardBody.appendChild(viewUnitsBtn);
  card.appendChild(cardBody);

  return card;
}

// 🔁 Recursive unit counter
function getTotalUnitCount(customerId, customers) {
  const customer = customers.find(c => c.customerId === customerId);
  let total = customer?.unitCount || 0;

  const children = customers.filter(c => c.parentCustomerId === customerId);
  for (const child of children) {
    total += getTotalUnitCount(child.customerId, customers);
  }

  return total;
}

// async function fetchUnits(customerId) {
//     try {
//         const response = await fetch(`/api/units?customerId=${customerId}`);
//         if (!response.ok) throw new Error("Failed to fetch units");
//         const units = await response.json();
//         displayUnits(units.results);
//     } catch (error) {
//         console.error("❌ Error fetching units:", error);
//     }
// }

// function displayUnits(units) {
//     const container = document.getElementById("dashboard");
//     container.innerHTML = "";

//     units.forEach(unit => {
//         const div = document.createElement("div");
//         div.className = "alert alert-info m-2";
//         div.textContent = `${unit.unitName} (ID: ${unit.unitId})`;
//         container.appendChild(div);
//     });
// }
